import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth-context';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ScanDetailPage } from './pages/ScanDetailPage';
import { BetaRequestsPage } from './pages/BetaRequestsPage';
import { FinOpsPage } from './pages/FinOpsPage';
import { DebugTestPage } from './pages/DebugTestPage';
import { UsersPage } from './pages/UsersPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { PromptPlaygroundPage } from './pages/PromptPlaygroundPage';
import { Layout } from './components/Layout';

export function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="text-slate-400">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/users/:userId" element={<UserDetailPage />} />
        <Route path="/scans/:scanSessionId" element={<ScanDetailPage />} />
        <Route path="/beta" element={<BetaRequestsPage />} />
        <Route path="/finops" element={<FinOpsPage />} />
        <Route path="/debug" element={<DebugTestPage />} />
        <Route path="/prompts" element={<PromptPlaygroundPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
